module.exports = __webpack_public_path__ + "static/media/yp-how-to-date-step1.fc0393c6.webp";